import {
  FuelPrice_Read,
  FuelPriceIndex_Read,
  FuelPriceIndex_Read_Nested,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class FuelPriceIndex {
  constructor(
    private _id: string,
    private _name: string,
    private _system: boolean,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get system() {
    return this._system;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(proto: FuelPriceIndex_Read) {
    return new FuelPriceIndex(
      proto.id,
      proto.name,
      proto.system,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}

export class FuelPriceIndexBasic {
  constructor(
    private _id: string,
    private _name: string,
    private _system: boolean,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get system() {
    return this._system;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(proto: FuelPriceIndex_Read_Nested) {
    return new FuelPriceIndexBasic(
      proto.id,
      proto.name,
      proto.system,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}

export class FuelPrice {
  constructor(
    private _id: string,
    private _date: string,
    private _price: number,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public get id() {
    return this._id;
  }
  public get date() {
    return this._date;
  }
  public get price() {
    return this._price;
  }
  public get createdAt() {
    return this._created_at;
  }
  public get updatedAt() {
    return this._updated_at;
  }
  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(proto: FuelPrice_Read): FuelPrice {
    return new FuelPrice(
      proto.id,
      proto.date,
      Number(proto.price),
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}
